module.exports = __webpack_public_path__ + "img/lixian.b42250d3.png";